import React from 'react'

export default function SourceOfferTotals({ totals }) {
  const money = value => `GBP ${(value / 100).toFixed(2)}`
  return <div aria-label="Recorded offer totals">
    <div>Subtotal (excluding VAT): {money(totals.net_minor)}</div>
    <div>VAT: {money(totals.tax_minor)}</div>
    <strong style={{ fontSize: 24 }}>Total: {money(totals.gross_minor)}</strong>
  </div>
}
